import { render, staticRenderFns } from "./ProjectViewSidebarActivitiesCard.vue?vue&type=template&id=777eab62&scoped=true"
import script from "./ProjectViewSidebarActivitiesCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarActivitiesCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarActivitiesCard.vue?vue&type=style&index=0&id=777eab62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777eab62",
  null
  
)

export default component.exports